// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"ad49ff15","315":"99c2fa7a","409":"e0970c68","631":"997a79b7","774":"0a6805a1","787":"211d69aa","805":"e390269c"}[chunkId] + ".chunk.js";
};